export default (superClass) => {
    return class extends superClass {

        get isActive() {
            return ! this.isArchived; 
        }
    
        get isArchived() {
            return this._data.archived;
        }
    }
}